import VueTheMask from 'vue-the-mask'
import vClickOutside from 'click-outside-vue3'
import textMiddleEllipsis from 'vue-text-middle-ellipsis'
import GodModal from '@/components/GodModal.vue'
import ExclamationAlertIcon from '@/components/svg/ExclamationAlertIcon.vue'
import { Skeletor } from 'vue-skeletor'
import 'vue-skeletor/dist/vue-skeletor.css'

export function setupExternal(app) {
  app.use(VueTheMask).use(vClickOutside).use(textMiddleEllipsis)
  app.component('GodModal', GodModal)
  app.component('ExclamationAlertIcon', ExclamationAlertIcon)
  // 'Skeletor' — официальное имя компонента из пакета vue-skeletor, так он используется в шаблонах
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('Skeletor', Skeletor)
}
